function generateJourneyId() {
  let userId = '';
  if (window.blGlobal && window.blGlobal.user && window.blGlobal.user.id) {
    userId = window.blGlobal.user.id;
  } else if (window.USER && window.USER.id) {
    userId = window.USER.id;
  }
  const enteringScreenTime = new Date().getTime();
  const journeyId = `${userId}-${enteringScreenTime}`;
  sessionStorage.setItem('new_tracker_journey_id', journeyId);
  return journeyId;
}

export default function getJourneyId() {
  return (
    sessionStorage.getItem('new_tracker_journey_id') || generateJourneyId()
  );
}
